import type { InferProps } from 'prop-types';
import type { ComponentClass } from 'react';
import { connect } from 'react-redux';

import type { RootState } from '@store';
import { updatePassword } from '@store/actions/action-system';

import ChangePassword, { type propTypes } from './change-password';

export default connect((state: RootState) => ({ system: state.system }), {
  updatePassword,
})(ChangePassword as ComponentClass<InferProps<typeof propTypes>>);
